import React, { useContext, useEffect, useState, useMemo } from 'react';
import collaborativeIcon from "../../../../Assets/Images/CollabrativeIcon.png";
import visionary from "../../../../Assets/Images/VISIONARY.png";
import strategic from "../../../../Assets/Images/StrategicIcon.png";
import performance from "../../../../Assets/Images/PerformaceIcon.png";
import HeaderPreview from '../../../GeneratePdf/HeaderPreview';
import FooterPreview from '../../../GeneratePdf/FooterPreview';
import GroupReportContext from '../../../../Context/GroupReportContext';
import { useGroupReportDate } from '../../../../Context/GroupReportDate';
import { initialDataLeaderShip } from './QuadrantInFocus';

const quadrantScores = {
  "PERFORMANCE": 1,
  "STRATEGIC": 2,
  "VISIONARY": 3,
  "COLLABORATIVE": 4
}

const sideLabels = [
  {
    "label": "COMMITMENTS",
    "bg": "#394554"
  },
  {
    "label": "BELIEFS",
    "bg": "#666666"
  },
  {
    "label": "MOTIVATIONS",
    "bg": "#394554"
  },
  {
    "label": "DRIVERS",
    "bg": "#666666"
  },
]

const Logo = (quadrant) => {
  switch (quadrant) {
    case 'COLLABORATIVE':
      return <img src={collaborativeIcon} alt="Collaborative" className="logo" />;
    case 'VISIONARY':
      return <img src={visionary} alt="Visionary" className="logo" />;
    case 'STRATEGIC':
      return <img src={strategic} alt="Strategic" className="logo" />;
    case 'PERFORMANCE':
      return <img src={performance} alt="Performance" className="logo" />;
    default:
      return null;
  }
};

const truncateText = (text, limit) => {
  if (text.length <= limit) return text;
  return text.substring(0, text.lastIndexOf(" ", limit)) + "...";
};

const LeadershipItemSecondGroup = ({ apiData, previewData, reportType, pageNumber }) => {
  // console.log('LeadershipItemSecondGroup apiData:', apiData);
  // console.log('LeadershipItemSecondGroup previewData:', previewData);

  const [dynamicData, setDynamicData] = useState([...initialDataLeaderShip]);
  const groupReportCtx = useContext(GroupReportContext)
  const { updateTablevaluelsPage2 } = useGroupReportDate();

  // Show items 13-28 (index 12-27)
  const displayData = useMemo(() => dynamicData.slice(12, 28), [dynamicData]);
  const allMembersDataArray = Object.values(apiData?.results || {});
  const allVariableSets = allMembersDataArray.map(el => el.variables);
  const allAssessmentDesignation = allMembersDataArray.map(el => el?.designation);
  const allAssessmentHash = allMembersDataArray.map(el => el.hash);
  const allAssessmentFullName = allMembersDataArray.map(el => el.fullName);

  // Optimized: Calculate allResults only when dependencies change
  const allResults = useMemo(() => {
    const results = [];
    displayData?.forEach((el, index) => {
      const res = groupReportCtx?.calculateQuestionScoreLeadership(quadrantScores?.[el.quadrant], allVariableSets, el.no, "in_focus", allAssessmentDesignation, allAssessmentHash, allAssessmentFullName);
      if (res?.averageScore !== null) {
        // Store only the average score value
        results.push(parseFloat(res.averageScore) || 0);
      }
    });
    return results;
  }, [displayData, allVariableSets, groupReportCtx?.calculateQuestionScoreLeadership]);

  const resultsSignature = useMemo(() => JSON.stringify(allResults), [allResults]);

  // Optimized: Store data only when allResults changes and has data
  useEffect(() => {
    if (allResults && allResults.length > 0) {
      updateTablevaluelsPage2(allResults);
    }
  }, [resultsSignature]);

  // console.log("allResults,apiData", allResults,apiData,displayData)

  return (
    <div>
      <HeaderPreview />
      <div className="page">

        <div className="content">
          <div className="table">
            <table>
              <thead>
                <tr className="tableHeader">
                  <th className="cellBandHeader"></th>
                  <th className="cellIndex">#</th>
                  <th className="cellQuadrant" style={{ width: "60px" }}>Quadrant</th>
                  <th className="cellLogo"></th>
                  <th className="cellQuestion-self">Question</th>
                  <th className="cellScore" style={{ paddingRight: "5px" }}>Score</th>
                </tr>
              </thead>
              <tbody>
                {displayData.map((item, index) => {
                  const isCategoryStart = index % 4 === 0;
                  const categoryIndex = Math.floor(index / 4);
                  const category = sideLabels[categoryIndex];
                  const rowClass = `tableRow ${isCategoryStart ? 'categoryStart' : ''}`.trim();
                  const scoreValue = allResults[index];

                  return (
                    <tr key={index} className={rowClass}>
                      {isCategoryStart && (
                        <td
                          className="cellBand categoryBand"
                          rowSpan={4}
                          style={{ backgroundColor: category?.bg }}
                        >
                          <span className="bandLabel">{category?.label}</span>
                        </td>
                      )}
                      <td className="cellIndex">{index + 13}.</td>
                      <td className="cellQuadrant">{item.quadrant}</td>
                      <td className="cellLogo">{Logo(item.quadrant)}</td>
                      <td className="cellQuestion-self">{item.question}</td>
                      <td className="cellScore">{scoreValue > 0 ? Number(scoreValue).toFixed(1) : "-"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
};

export default LeadershipItemSecondGroup;
